import { PrimaryAISparkleIcon } from '../icons/PrimaryAISparkles';
import styles from "./JobStatusMessage.module.css";


export interface StatusMessageProps {
  title: string;
  description: string;
}

export const StatusMessage = ({ title, description }: StatusMessageProps) => (
  <div className={styles.statusSection}>
    <div className={styles.statusButtonContainer}>
      <button className={styles.statusButton}>
        <div className={styles.statusIcon}>
          <PrimaryAISparkleIcon/>
        </div>
        <div className={styles.statusTitle}>{title}</div>
      </button>
      <div className={styles.statusDescription}>{description}</div>
    </div>
  </div>
);
